import Vue from 'vue';
import Router from 'vue-router';

import { routes as Home } from '@/modules/Home';
import { routes as Dashboard } from '@/modules/Dashboard';
import { routes as Info } from '@/modules/Info';
import { routes as Account } from '@/modules/Account';
import { routes as Auth } from '@/modules/Auth';
import { routes as Docs } from '@/modules/Docs';
import { routes as FaqRoutes } from '@/modules/Faq';

const { Faq, FaqDocs } = FaqRoutes;

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
  ],

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.addRoutes([
  Home,
  Dashboard,
  Info,
  Account,
  Auth,
  Docs,
  Faq,
  FaqDocs,
]);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js